export const embed = /\/embed\//;
export const override = /^(recommended|votes)$/;
export const paginate = /pagination/;
export const skip = /(pagination|bookmark|vote|toggle|copy)/;
export const video = /(youtu\.be|youtube\.com|video\.tv\.adobe\.com)/;
export const youtube = /(youtu\.be|youtube\.com)/;
